import type { ReactNode, Ref } from 'react';
import { Link } from 'react-router';
export function ServerCardFrame({
  name,
  href,
  state,
  children,
  className = '',
  exiting,
  itemRef,
}: {
  name: string;
  href: string;
  state: ReactNode;
  children: ReactNode;
  className?: string;
  exiting?: boolean;
  itemRef?: Ref<HTMLDivElement>;
}) {
  return (
    <div className={'card server-card ' + className} inert={exiting} ref={itemRef}>
      <div className="server-card-title">
        <h2>
          <Link to={href} className="stretched-link">
            {name}
          </Link>
        </h2>
        {state}
      </div>
      {children}
    </div>
  );
}
